module.exports = __webpack_public_path__ + "img/bell.bf891fac.svg";